import React from "react";
import dayjs from "dayjs";

const GeneralLedgerTable = ({ data = [], onDelete, onEdit }) => {
  const formatPrice = (price) =>
    price
      ? new Intl.NumberFormat("id-ID", {
          style: "decimal",
          minimumFractionDigits: 2,
        }).format(price)
      : "";

  // Flatten all journals + details
  const rows = data.flatMap((journal) =>
    journal.details.map((detail, idx) => ({
      id: `${journal.id}-${idx}`,
      journal_id: journal.id,
      transaction_date: journal.transaction_date,
      voucher: journal.id,
      reference_number: journal.reference_number || "-",
      description: journal.description || "-",
      account_code: detail.account?.account_code || "",
      account_name: detail.account?.account_name || "",
      debit_amount: detail.debit_amount || 0,
      credit_amount: detail.credit_amount || 0,
      member_name: "-",
      member_number: "-",
      reference_type: journal.reference_type || "-",
    }))
  );

  // Group by journal entry id
  const grouped = rows.reduce((acc, cur) => {
    if (!acc[cur.journal_id]) acc[cur.journal_id] = [];
    acc[cur.journal_id].push(cur);
    return acc;
  }, {});
  const journals = Object.values(grouped);

  return (
    <div className="w-full overflow-x-auto">
      <table className="w-full border border-collapse text-sm">
        <thead className="bg-blue-900 text-white">
          <tr>
            <th className="p-2 border text-center">No</th>
            <th className="p-2 border text-center">Tanggal</th>
            <th className="p-2 border text-center">Kode Perk.</th>
            <th className="p-2 border text-center">Perkiraan</th>
            <th className="p-2 border text-center">Voucher</th>
            <th className="p-2 border text-center">No Slip</th>
            <th className="p-2 border text-center">Keterangan</th>
            <th className="p-2 border text-center">Debet</th>
            <th className="p-2 border text-center">Kredit</th>
            <th className="p-2 border text-center">Nama</th>
            <th className="p-2 border text-center">No. Agt</th>
            <th className="p-2 border text-center">Rek. Agt</th>
            <th className="p-2 border text-center">Aksi</th>
          </tr>
        </thead>
        <tbody>
          {journals.length > 0 ? (
            journals.map((details, i) => (
              <>
                {details.map((row, j) => (
                  <tr key={row.id} className="hover:bg-gray-50">
                    {/* No & tanggal hanya tampil di baris pertama */}
                    {j === 0 && (
                      <>
                        <td
                          rowSpan={details.length}
                          className="p-2 border text-center align-top"
                        >
                          {i + 1}
                        </td>
                        <td
                          rowSpan={details.length}
                          className="p-2 border text-center align-top whitespace-nowrap"
                        >
                          {dayjs(row.transaction_date).format("DD/MM/YYYY")}
                        </td>
                      </>
                    )}

                    {/* Kode akun & nama akun */}
                    <td className="p-2 border text-center whitespace-nowrap">
                      {row.account_code}
                    </td>
                    <td className="p-2 border whitespace-nowrap">
                      {row.account_name}
                    </td>

                    {/* Voucher, No Slip, Keterangan hanya tampil sekali */}
                    {j === 0 && (
                      <>
                        <td
                          rowSpan={details.length}
                          className="p-2 border text-center align-top"
                        >
                          {row.voucher}
                        </td>
                        <td
                          rowSpan={details.length}
                          className="p-2 border text-center align-top"
                        >
                          {row.reference_number}
                        </td>
                        <td
                          rowSpan={details.length}
                          className="p-2 border align-top"
                        >
                          {row.description}
                        </td>
                      </>
                    )}

                    {/* Debit & Kredit */}
                    <td className="p-2 border text-right">
                      {row.debit_amount ? formatPrice(row.debit_amount) : ""}
                    </td>
                    <td className="p-2 border text-right">
                      {row.credit_amount ? formatPrice(row.credit_amount) : ""}
                    </td>

                    {/* Nama, No Agt, Rek Agt hanya tampil sekali */}
                    {j === 0 && (
                      <>
                        <td
                          rowSpan={details.length}
                          className="p-2 border text-left align-top"
                        >
                          {row.member_name}
                        </td>
                        <td
                          rowSpan={details.length}
                          className="p-2 border text-center align-top"
                        >
                          {row.member_number}
                        </td>
                        <td
                          rowSpan={details.length}
                          className="p-2 border text-center align-top"
                        >
                          {row.reference_type}
                        </td>
                        <td
                          rowSpan={details.length}
                          className="p-2 border text-center align-top"
                        >
                          <div className="flex gap-2 justify-center">
                            <button
                              onClick={() => onEdit && onEdit(row.journal_id)}
                              className="btn btn-sm bg-warning text-white hover:bg-yellow-600"
                              title="Edit Jurnal"
                            >
                              <i className="mgc_edit_line"></i>
                            </button>
                            <button
                              onClick={() => onDelete && onDelete(row.journal_id)}
                              className="btn btn-sm bg-danger text-white hover:bg-red-700"
                              title="Hapus Jurnal"
                            >
                              <i className="mgc_delete_line"></i>
                            </button>
                          </div>
                        </td>
                      </>
                    )}
                  </tr>
                ))}
              </>
            ))
          ) : (
            <tr>
              <td colSpan={13} className="p-3 text-center border">
                Tidak Ada Data
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default GeneralLedgerTable;
